import { useContext, useEffect, useState } from 'react'
import {
  CardHeader,
  Card,
  CardBody,
  Button,
  CardText,
  FormGroup,
  UncontrolledCollapse,
  Input,
} from 'reactstrap'
import { CaretDown } from 'react-bootstrap-icons'
import FeedbackContext from '../../store/feedbackContext'
import UserContext from '../../store/userContext'
import './feedback.scss'

const FeedBack = ({ visit_id }) => {
  const [feedback, setFeeback] = useState('')
  const [loading, setLoading] = useState(false)
  const [actionLoading, setActionLoading] = useState(false)
  const feedbackCtx = useContext(FeedbackContext)
  const userCtx = useContext(UserContext)
  useEffect(() => {
    async function fetchApi() {
      await feedbackCtx.loadData(visit_id)
    }
    fetchApi()
  }, [])
  const _submitFeeback = async () => {
    if (feedback) {
      setActionLoading(true)
      await feedbackCtx.saveData({
        sup_visit_id: visit_id,
        body: feedback,
      })
      setActionLoading(false)
    }
  }
  const deleteFeeback = async (id) => {
    setActionLoading(true)
    await feedbackCtx.removeData(id)
    setActionLoading(false)
  }

  return (
    <>
      {!loading && (
        <FeedbackContext.Consumer>
          {({ data }) => (
            <Card className="feedback">
              <CardHeader
                tag="h5"
                id="feedback"
                className="head d-flex justify-content-between"
              >
                FeedBacks ({data.length})
                <CaretDown className="mt-1" />
              </CardHeader>
              <UncontrolledCollapse toggler="#feedback">
                <CardBody>
                  {data.map((item) => (
                    <div key={`feedback-list-${item.id}`}>
                      <CardText className="se-content">
                        <p>{item.member.username}</p>
                        <p>{item.created_at}</p>
                      </CardText>
                      <CardText className="main-content">{item.body}</CardText>
                      {userCtx.eachData.id == item.member.id && (
                        <Button
                          className="btn btn-danger btn-sm mt-2"
                          onClick={() => deleteFeeback(item.id)}
                          disabled={actionLoading}
                        >
                          Delete
                        </Button>
                      )}
                      <hr></hr>
                    </div>
                  ))}
                </CardBody>
                <CardBody>
                  <FormGroup>
                    <Input
                      type="textarea"
                      name="feedback"
                      placeholder="feedback..."
                      value={feedback}
                      onChange={(e) => setFeeback(e.target.value)}
                    />
                  </FormGroup>
                  <FormGroup className="d-flex justify-content-end mt-3">
                    <Button
                      outline
                      className="add-btn"
                      onClick={() => _submitFeeback()}
                      disabled={actionLoading}
                    >
                      Submit
                    </Button>
                  </FormGroup>
                </CardBody>
              </UncontrolledCollapse>
            </Card>
          )}
        </FeedbackContext.Consumer>
      )}
    </>
  )
}

export default FeedBack
